import { render } from "./Subtitle.vue?vue&type=template&id=59964648&ts=true"
import script from "./Subtitle.vue?vue&type=script&lang=ts"
export * from "./Subtitle.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/levelpro-feed-widget/levelpro-feed-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__